/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.feed.postgate'

export { $nsid }

/** Record defining interaction rules for a post. The record key (rkey) of the postgate record must match the record key of the post, and that record must be in the same repository. */
type Main = {
  $type: 'app.bsky.feed.postgate'
  createdAt: l.DatetimeString

  /**
   * Reference (AT-URI) to the post record.
   */
  post: l.AtUriString

  /**
   * List of AT-URIs embedding this post that the author has detached from.
   */
  detachedEmbeddingUris?: l.AtUriString[]

  /**
   * List of rules defining who can embed this post. If value is an empty array or is undefined, no particular rules apply and anyone can embed.
   */
  embeddingRules?: (l.$Typed<DisableRule> | l.Unknown$TypedObject)[]
}

export type { Main }

/** Record defining interaction rules for a post. The record key (rkey) of the postgate record must match the record key of the post, and that record must be in the same repository. */
const main = l.record<'tid', Main>(
  'tid',
  $nsid,
  l.object({
    createdAt: l.string({ format: 'datetime' }),
    post: l.string({ format: 'at-uri' }),
    detachedEmbeddingUris: l.optional(
      l.array(l.string({ format: 'at-uri' }), { maxLength: 50 }),
    ),
    embeddingRules: l.optional(
      l.array(
        l.typedUnion(
          [l.typedRef<DisableRule>((() => disableRule) as any)],
          false,
        ),
        { maxLength: 5 },
      ),
    ),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

/** Disables embedding of this post. */
type DisableRule = { $type?: 'app.bsky.feed.postgate#disableRule' }

export type { DisableRule }

/** Disables embedding of this post. */
const disableRule = l.typedObject<DisableRule>(
  $nsid,
  'disableRule',
  l.object({}),
)

export { disableRule }
